var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.75 25.1349L25.6158 21.6512V11.6558L16.7958 6.64186V0H15.2374V6.64186L6.38421 11.6558V21.6837L0.25 25.1349L1.04579 26.4698L7.18 22.986L16 28L24.82 22.986L30.9542 26.4698L31.75 25.1349ZM23.2616 12.0791L16 16.214L8.73842 12.0791L16 7.97674L23.2616 12.0791ZM16.7958 17.5488L24.0574 13.414V21.6512L16.7958 25.786V17.5488ZM7.94263 13.414L15.2042 17.5488V25.786L7.94263 21.6512V13.414Z",
    fill: "#49454F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.1a2e1112c53a46efc24452ff3aefd81a.svg";
export { ForwardRef as ReactComponent };